import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const RefundPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div
      className="refund-policy py-5"
      style={{
        background: "linear-gradient(135deg, #f5fff5, #ffffff)",
        minHeight: "100vh",
      }}
    >
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-down">
          <h1 className="fw-bold text-success">Refund Policy</h1>
          <p className="text-muted">Last updated: August 2025</p>
        </div>

        <div className="card shadow-lg border-0 rounded-4 p-4" data-aos="fade-up">
          <p>
            At <b>RoupanNaturals</b>, we value your trust and satisfaction. If you are not
            completely happy with your purchase, our <b>Refund Policy</b> ensures a fair and
            smooth process.
          </p>

          <h4 className="text-success mt-4">1. Eligibility for Refund</h4>
          <ul>
            <li>If Product ordered is different from what you received.</li>
            <li>Items must be unused, unopened, and in original packaging.</li>
            <li>Return requests must be made within <b>7 days</b> of delivery.</li>
            <li>We do not accept any exchange or replacement.</li>
          </ul>

          <h4 className="text-success mt-4">2. Refund Process</h4>
          <ul>
            <li>Contact us at <b>support@roupannaturals.com</b> with your order details.</li>
            <li>Once approved, return instructions will be shared.</li>
            <li>Refunds are credited within <b>5–7 business days</b> after product inspection.</li>
          </ul>

          
          <h4 className="text-success mt-4">3. Shipping Costs</h4>
          <p>
            Return shipping costs are borne by the customer unless the return is due to
            a <b>defective or wrong product</b> sent by us.
          </p>

          <h4 className="text-success mt-4">4. Contact Us</h4>
          <p>
            For refund-related queries, reach out at:  
            <b>Email:</b> roupannaturals@gmail.com 
            <b>Phone:</b> +91 8700723140
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
